export default __webpack_public_path__ + "static/media/iDocCarFont.79e954ea.svg";